import { useMemo } from "react"

import { format } from "date-fns/format"

import { useTranslation } from "@l2r-front/l2r-i18n"
import { I18N_NAMESPACE, useCampaignProject } from "@l2r-front/l2r-shared-campaign"
import { TruncableText, Typography } from "@l2r-front/l2r-ui"
import { formatNumber } from "@l2r-front/l2r-utils"

import * as Styled from "./CampaignDetails.styled"

const DATE_FORMAT = "dd/MM/yyyy"

export const CampaignDetails = (props) => {

    const { campaign } = props

    const tagsChips = useMemo(() => {
        return (campaign.tags || []).map(tag => ({ label: tag, value: tag }))
    }, [campaign])

    const { t } = useTranslation(I18N_NAMESPACE)
    const { data: project } = useCampaignProject()

    return <Styled.CampaignDescription>
        {parseFloat(campaign.cost) ? <Styled.CampaignItemContainer>
            <Typography variant="Desktop & Mobile/Heading/H3">
                {t(I18N_NAMESPACE, "components.campaignDetails.cost")}
            </Typography>
            <Typography variant="Desktop & Mobile/Body/Regular">
                {formatNumber(campaign.cost) + (project?.currency?.code ? ` ${project.currency.code}` : "")}
            </Typography>
        </Styled.CampaignItemContainer> : null}
        <Styled.CampaignItemContainer>
            <Typography variant="Desktop & Mobile/Heading/H3">
                {t(I18N_NAMESPACE, "components.campaignDetails.dates")}
            </Typography>
            <Typography variant="Desktop & Mobile/Body/Regular">
                {`${format(campaign.date_start, DATE_FORMAT)}  ${(campaign.date_end ? `- ${format(campaign.date_end, DATE_FORMAT)}` : "")}`}
            </Typography>
        </Styled.CampaignItemContainer>
        <Styled.CampaignItemContainer>
            <Typography variant="Desktop & Mobile/Heading/H3">
                {t(I18N_NAMESPACE, "components.campaignDetails.company")}
            </Typography>
            <Typography
                color={campaign.company_name ? undefined : "text/tertiary"}
                variant="Desktop & Mobile/Body/Regular"
            >
                {campaign.company_name || t(I18N_NAMESPACE, "components.campaignDetails.companyNotSet")}
            </Typography>
        </Styled.CampaignItemContainer>
        <Styled.CampaignItemContainer>
            <Typography variant="Desktop & Mobile/Heading/H3">
                {t(I18N_NAMESPACE, "components.campaignDetails.tags")}
            </Typography>
            {tagsChips?.length ? <Styled.ChipList values={tagsChips} /> : "-"}
        </Styled.CampaignItemContainer>
        <Styled.CampaignItemContainer>
            <Typography variant="Desktop & Mobile/Heading/H3">
                {t(I18N_NAMESPACE, "components.campaignDetails.comment")}
            </Typography>
            {campaign.comment ? <TruncableText fontSize={16} maxHeight={24}>
                {campaign.comment}
            </TruncableText> : <Typography
                color={"text/tertiary"}
                variant="Desktop & Mobile/Body/Regular"
            >
                {t(I18N_NAMESPACE, "components.campaignDetails.commentNotSet")}
            </Typography>}
        </Styled.CampaignItemContainer>
    </Styled.CampaignDescription>
}